import type { TFunction } from 'i18next';

export interface NumericRangeLimits {
  min?: number;
  max?: number;
  unit?: string;
}

export const formatNumericRangeBound = (value: number): string => new Intl.NumberFormat('en-US', { maximumFractionDigits: 6 }).format(value);

export function getSupportedNumericRangeText(t: TFunction, { min, max, unit = '' }: NumericRangeLimits): string | null {
  const hasMin = typeof min === 'number';
  const hasMax = typeof max === 'number';
  if (!hasMin && !hasMax) return null;

  const formattedUnit = unit.trim();

  if (hasMin && hasMax) {
    const formattedMin = formatNumericRangeBound(min);
    const formattedMax = formatNumericRangeBound(max);
    return t('numericRange.supportedRange.between', {
      defaultValue: formattedUnit ? 'Supported range: {{min}} to {{max}} {{unit}}' : 'Supported range: {{min}} to {{max}}',
      min: formattedMin,
      max: formattedMax,
      unit: formattedUnit,
    });
  }

  if (hasMin) {
    const formattedMin = formatNumericRangeBound(min);
    return t('numericRange.supportedRange.minOnly', {
      defaultValue: formattedUnit ? 'Supported range: at least {{min}} {{unit}}' : 'Supported range: at least {{min}}',
      min: formattedMin,
      unit: formattedUnit,
    });
  }

  const formattedMax = formatNumericRangeBound(max as number);
  return t('numericRange.supportedRange.maxOnly', {
    defaultValue: formattedUnit ? 'Supported range: at most {{max}} {{unit}}' : 'Supported range: at most {{max}}',
    max: formattedMax,
    unit: formattedUnit,
  });
}
